import personalBg from "../../../assets/images/personal-bg.svg";
import loginBg from "../../../assets/images/login-bg.svg";
import loginBg2 from "../../../assets/images/login-bg.png";

import Button from "../../../components/Button";
import Close from "../../../assets/images/X.svg";
import { useDispatch } from "react-redux";
import { changeTourStatusThunk } from "../../../lib/service/tours/toursStatusSlice";
import { useState } from "react";

function CancelBooking({ onClick, itemId, title, tourType }) {
  const dispatch = useDispatch();
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [isCloseLoaded, setIsCloseLoaded] = useState(false);

  const handleChangeStatus = (status, tourId) => {
    dispatch(changeTourStatusThunk({ status, tourId }))
      .unwrap()
      .then((response) => {})
      .catch((error) => {
        console.error("Failed to change status:", error);
      });
    onClick();
  };

  return (
    <div className="leap-relative">
      <img
        src={loginBg2}
        loading="lazy"
        alt="loginBg"
        className="leap-h-[25rem] md:leap-h-[17rem] leap-w-[30rem]"
        onLoad={() => setIsImageLoaded(true)}
      />
      <img
        src={Close}
        alt="Close"
        className="leap-hidden"
        onLoad={() => setIsCloseLoaded(true)}
      />

      {isImageLoaded && (
        <>
          <div className="leap-scale-75 leap-pt-10 md:leap-w-full leap-absolute leap-top-1/2 -leap-translate-x-[50%] -leap-translate-y-[60%] leap-left-1/2 leap-flex leap-flex-col leap-gap-10">
            <div className="leap-flex leap-flex-col leap-gap-14">
              <h1 className="leap-text-4xl leap-font-bold leap-text-center leap-uppercase leap-text-[#EB3DF7]">
                Cancel Tour
              </h1>
              <p className="leap-text-xl md:leap-text-xl leap-font-bold leap-text-center leap-text-white">
                Are you sure you want to cancel
                <br />
                <br />
                <span className="leap-text-[#73FAFD] leap-text-base">
                  {title} ({tourType})
                </span>
              </p>
            </div>

            <div className="leap-flex-col leap-items-center md:leap-flex-row leap-my-auto leap-flex leap-gap-4 leap-justify-center">
              <div>
                <Button
                  text="No, I changed my Mind"
                  bgColor="transparent"
                  textColor="#73FAFD"
                  customStyles="!leap-w-72 md:!leap-w-32 lg:!leap-w-60 !leap-text-base lg:!leap-text-lg leap-border-2 leap-border-solid leap-border-[#73FAFD]"
                  onClick={onClick}
                />
              </div>
              <div>
                <Button
                  text="Yes, Please Cancel"
                  bgColor="#73FAFD"
                  textColor="black"
                  customStyles="!leap-w-72 md:!leap-w-32 lg:!leap-w-60 !leap-text-base lg:!leap-text-lg"
                  onClick={() => handleChangeStatus("cancelled", itemId)}
                />
              </div>
            </div>
          </div>
          <button onClick={onClick}>
            <img
              src={Close}
              alt="Close"
              className="leap-absolute leap-top-[8px] leap-left-[8px] leap-w-6 leap-h-6 md:leap-w-8 md:leap-h-8"
              loading="lazy"
            />
          </button>{" "}
        </>
      )}
    </div>
  );
}

export default CancelBooking;
